module.exports = __webpack_public_path__ + "img/bnr_popup_sp.cd728274.jpg";